

import { Box, Button, Input, Slider, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { isUndefined } from 'lodash';
import React, { useEffect, useState } from 'react';
import {Decimal} from 'decimal.js';


const AirbnbSlider = withStyles({
  root: {
    color: '#0061e3',
    height: 4,
    padding: '13px 0',
  },
  thumb: {
    height: 14,
    width: 14,
    backgroundColor: 'black',
    border: '1px solid currentColor',
    marginTop: -6,
    marginLeft: -7,
    boxShadow: '#ebebeb 0 2px 2px',
    '&:focus, &:hover, &$active': {
    },
  },
  active: {},
  track: {
    height: 4,
  },
  rail: {
    color: '#d8d8d8',
    opacity: 1,
    height: 4,
  },
})(Slider);
function AirbnbThumbComponent(props) {
  return (
    <span {...props}>
      <span className="bar" />
      <span className="bar" />
      <span className="bar" />
    </span>
  );
}
export default function FilterView(props) {
  const { id, language, filter, setCustomFilter , curCatalog,OnExtra,richText} = props;
  const [flush, setViewFlush]=useState(false);
  const setFlush =(_flush) => {
    setViewFlush(_flush);
    let request = '';
    let count = 0;
    for (let i=0;i<filter.length;i++) {
      const info = filter[i];
      let _url = 'filters['+count+']'+'[0]='+filter[i][0];
      // request=request+'filters['+count+']'+'[0]='+filter[i][0];
      let _cou = 0;
        for (let m=0;m<filter[i][1].length;m++) {
          if (filter[i][1][m][6]) {
            _url = _url +'&'+
                      'filters['+count+']'+'[1]['+_cou+']='+filter[i][1][m][0];                   
            _cou++;
          }
        }     
      if (_cou>0) {
        count++;
        request= request+_url+'&';
      }
              
    }
    console.log("request.substring(0, request.length-1)===",request.substring(0, request.length-1))
    if (setCustomFilter)
      setCustomFilter(request.substring(0, request.length-1));
  };
  if(!language)
    return null
  return (<Box style={{justifyContent:'center', flexDirection:'column', alignItems:'center', width:'100%', height:'100%', overflow:'auto',background:'white'}}>
    <Box style={{width:'100%' }}>

      <DeleteView richText={richText} OnExtra={OnExtra} id={id} curCatalog={curCatalog} flush={flush} setFlush={setFlush} filter={filter} language={language}></DeleteView>
      {filter?.length>0&&<Box style={{border:'1px solid #d2d2d2',background:'#F1F2F1',margin:'20px'}}>
         {filter?.map((item,i) => {
        return (<CommenView key={i} flush={flush} setFlush={setFlush} language={language} item={item}></CommenView>);
      })} 
      </Box>}
     
    </Box>

  </Box>);
}

const CommenView:React.FC =(props) => {
  const {language, item, setFlush, flush} = props;
  const [hide, setHide] = useState(true);
  const [showExtra,setShowExtra] = useState(false)
  const handleResize = () => {
    let a = document.getElementById('status'+item[0])
    if(a.offsetHeight>68){ 
      setShowExtra(true)
    }else{
      setShowExtra(false)
    }
  };
  useEffect(()=>{
     // 监听
     window.addEventListener("resize", handleResize);
     // 销毁
     return () => window.removeEventListener("resize", handleResize);
 
  },[])

  return (
    <Box style={{background:'#F1F2F1',border:'1px solid #d2d2d2',margin:'-1px', width:'100%', display:'flex', justifyContent:'center', flexDirection:'row'}}>
      <Box  style={{padding:'15px',height:'41px',background:'#F1F2F1', paddingLeft:'20px', display:'flex', alignItems:'center', width:'200px'}}>
        <Box style={{fontSize:'15px', color:'black', width:'100%'}}>{language?.features[item[0]]+(item[3]?(' ('+item[3]+')'):'') }</Box>
      </Box>
      <Box style={{height:hide?'41px':'unset',width:'100%',overflow:'hidden'}}>
        <Box id={'status'+item[0]} style={{ width:'100%',display:'flex',flexDirection:'row',flexWrap:'wrap',overflow:hide?'hidden':'unset'}}>
          {item[1].map((select) => {
            // select[7] = item[1]. 
            return ( <SelectView key={select.id} flush={flush} setFlush={setFlush} item={select} language={language} name={(!isUndefined(language?.features[item[0]]))?language?.features[item[0]]:item[0]}></SelectView>);
          })}
        </Box>
      </Box>
      
      {showExtra&&<Box style={{width:'60px',display:'flex', alignItems:'flex-end',paddingBottom:'10px'}}>
      <Typography onClick={()=>{
        setHide(!hide)
      }} color="textPrimary" style={{fontSize:'14px'}}>
          {hide?'展开':'收起'}
        </Typography>
      </Box>}
         
    </Box>);
};

// const RangeView:React.FC = (props) => {
//   const {item, values, unit, setFlush, flush, showFilter} = props;

//   const [rangs, setRangs] = useState([]);
//   const [mValue, setMValue] = useState(null);
//   const [inputValue, setInputValue] = useState(null);

//   //输入数值转range数值
//   const CoverToRange = (value1, value2) => {
//     setMValue([value1==null?mValue[0]:new Decimal(value1*100).div(new Decimal(rangs[1]-rangs[0])).sub(new Decimal(rangs[0]*100).div(new Decimal(rangs[1]-rangs[0]))),
//       value2==null?mValue[1]:new Decimal(value2*100).div(new Decimal(rangs[1]-rangs[0])).sub(new Decimal(rangs[0]*100).div(new Decimal(rangs[1]-rangs[0])))]);
//   };
//   const CoverToInputValue = (value1, value2) => {
//     setInput(
//       [value1==null?inputValue[0]:new Decimal(rangs[1]-rangs[0]).mul(new Decimal(value1)).div(new Decimal(100)).add(new Decimal(rangs[0])).toString(),
//         value2==null?inputValue[1]:new Decimal(rangs[1]-rangs[0]).mul(new Decimal(value2)).div(new Decimal(100)).add(new Decimal(rangs[0])).toString(),
//       ]
//     );
//   };
//   const setInput= (values) => {     
//     setInputValue(values);
//     if (values[0]==rangs[0]&& values[1]==rangs[1]) {
//       item[6] = false;
//     } else {
//       item[6] = true;
//     }
//     item[5] = values;

//   };
//   useEffect(() => { 
//     let max = 0;
//     let min = 0;
//     values.map(item => {

//       max = max==0?item[0]:(max>item[0]?max:item[0]);
//       min = min==0?item[0]:(min>item[0]?item[0]:min);
//     });
//     rangs[0] = min;
//     rangs[1] = max;
//     if (!isUndefined(item[5]) && item[5]!=null) {
//       CoverToRange(item[5][0], item[5][1]);
//       setInput([item[5][0], item[5][1]]);
//       return;
//     }
//     CoverToRange(min, max);
//     setInput([min, max]);
//   }, [flush]);
//   if (!rangs || !mValue )
//     return null;
//   return (<Box style={{width:'100%', background:'white', padding:'10px 20px 10px 20px'}}>
//     <AirbnbSlider
//       min={0}
//       max={100}
//       onMouseUp={(e) => {
//         console.log('eee', e );
//       }}
//       ThumbComponent={AirbnbThumbComponent}
//       getAriaLabel={(index) => (index === 0 ? 'Minimum price' : 'Maximum price')}
//       value={[mValue[0].toNumber(), mValue[1].toNumber()]}
//       onChangeCommitted={() => {
//         setFlush(!flush);
//       }}
//       onChange={(e, _values) => {
//         setMValue([new Decimal( _values[0]), new Decimal( _values[1]) ]);
//         CoverToInputValue(_values[0], _values[1]);

//       }}
//     />

//     <Box style={{display:'flex', flexDirection:'row', justifyContent:'space-between', paddingLeft:'6rpx', paddingTop:'20rpx', paddingRight:'12rpx'}}>
//       <Box style={{display:'flex', flexDirection:'row', alignItems:'center',marginLeft:'-6px'}}>
//         <Input className={'inputS'} 

//           name='value'
//           disableUnderline
//           placeholder=''
//           value={inputValue[0]}
//           onBlur={(event) => {
//             let value = event.target.value;
//             if (value>rangs[1])
//             {
//               value = rangs[1];
//             }
//             if (value<rangs[0]) {
//               value=rangs[0];
//             }
//             CoverToRange(value, null);
//             setInput([value, inputValue[1]]);
//             setFlush(!flush);
//           }}
//           onKeyDown={(event) => {
//             if (event.keyCode==13) {
//               let value = event.target.value;
//               if (value>rangs[1])
//               {
//                 value = rangs[1];
//               }
//               if (value<rangs[0]) {
//                 value=rangs[0];
//               }
//               CoverToRange(value, null);
//               setInput([value, inputValue[1]]);
//               setFlush(!flush);
//             }
//           }} 
//           onChange={(event) => {
//             const value = event.target.value;

//             setInput([value, inputValue[1]]);

//             // let _value  = new Decimal(event.detail.value).mul(new Decimal(100).div(new Decimal(rangs[1]-rangs[0])));

//           }}
//         />
//       </Box>
//       <Box style={{display:'flex', flexDirection:'row', alignItems:'center',justifyContent:'flex-end',marginRight:'-6px'}}> 
//         <Input className={'inputS' }
//         style={{textAlign:'right'}}
//           name='value1'
//           disableUnderline
//           title=''
//           placeholder=''
//           value={inputValue[1]}
//           onBlur={(event) => {
//             let value = event.target.value;
//             if (value>rangs[1])
//             {
//               value = rangs[1];
//             }
//             if (value<rangs[0]) {
//               value=rangs[0];
//             } 
//             CoverToRange(null, value);
//             setInput([inputValue[0], value]);
//             setFlush(!flush);
//           }
//           }
//           onChange={(event) => {
//             const value = event.target.value;

//             setInput([inputValue[0], value]);

//           }}
//           onKeyDown={(event) => {

//             if (event.keyCode==13) {
//               let value = event.target.value;
//               if (value>rangs[1])
//               {
//                 value = rangs[1];
//               }
//               if (value<rangs[0]) {
//                 value=rangs[0];
//               } 
//               CoverToRange(null, value);
//               setInput([inputValue[0], value]);
//               setFlush(!flush);
//             }
//           }} 
//         />
//       </Box>

//     </Box>
//   </Box>);
// };
const SelectView:React.FC = (props) => {
  const {language, item, flush, setFlush,name} = props;
  item[7] = name;
  return (
    <Box  onClick={() => {
      item[6] = item[6]==null?true:!item[6];
      setFlush(!flush);
    }} style={{margin:'10px 10px 10px 10px', display:'flex', flexDirection:'row', padding:'8rpx'}}>
      {/* <img src = {item[6]?'/images/checked.svg':'/images/unchecked.svg'} style={{width:'18px', height:'18px'}}/> */}
      <Box style={{fontSize:'14px', paddingLeft:'2px'}}>
      <Typography style={{color:item[6]?'red':'#3173e0',fontSize:"14px",cursor:'pointer'}} >
      {(!isUndefined(language?.fValues[item[0]]))?language?.fValues[item[0]]:item[0] }
        </Typography>
      </Box>
    </Box>
  );
};



const DeleteView:React.FC =(props) => {
  const {id,language, filter, setFlush, flush, curCatalog,OnExtra,richText} = props;
  const [allSelect, setAllSelect] = useState([]);
  //检索所有可选项
  const getSelectFilter = () => {
    const all =[];
    for (let i=0;i<filter?.length;i++) {
      const info = filter[i];
      for (let m=0;m<filter[i][1].length;m++) {
        filter[i][1][m][6]=filter[i][1][m][6]==null?false:filter[i][1][m][6];
        
        all.push(filter[i][1][m]);
      }
      console.log("all====",all,filter)
    }
    setAllSelect(all);
  };
  useEffect(()=>{
    setAllSelect([])
  },[id])
  useEffect(() => {
    getSelectFilter(); 
  }, [flush]);
 
  return (
    <Box style={{marginTop:'14px', width:'100%', display:'flex',justifyContent:'space-between', flexDirection:'row',background:'white'}}>
       <Typography style={{color:'black',fontSize:"20px",padding:'20px'}} > 
          {curCatalog?(curCatalog?.cgName?.zh):''}
        </Typography>
        {(curCatalog&&richText!=null)&&<Box style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
           <Button color="primary" variant='contained'
          onClick={()=>{OnExtra()}} style={{ background:'red' }}
        >
          系列介绍
        </Button> 
        </Box>}
       
      <Box style={{background:'white',  padding:'8px', display:'flex', flexWrap:'wrap',flexGrow:'1',width:'0px'}}>
        {allSelect.map((item, i) => {
          if (item[6])
            return (<DeleteItemView language={language}  item={item} flush={flush} setFlush={setFlush} id={i}></DeleteItemView>); 
          else 
            return null;
        })}
      </Box>
      <Box>
          <DeleteAllView allSelect={allSelect} flush={flush} setFlush={setFlush} filter={filter}></DeleteAllView>
        </Box>
        
          
    </Box>);
};
const DeleteItemView:React.FC = (props) => {
  const {id, setFlush, item, flush, language} = props;
  return (  
    <Box  style={{marginTop:'2px',marginBottom:'2px',border:'1px solid #d2d2d2',paddingLeft:'10px',paddingRight:'10px',display:'flex', flexDirection:'row', padding:'10rpx', alignItems:'center', marginRight:'8px'}}>
      <Typography style={{color:'black',fontSize:"14px"}} > 
          {item[7]+':'}
        </Typography>
        <Typography style={{color:'red',fontSize:"14px",paddingLeft:'8px'}} > 
        {language?.fValues[item[0]]?language?.fValues[item[0]]:item[0]}
        </Typography>
        <Box onClick={() => {
            item[6]=  item[6]==null?false:(!item[6]);
            setFlush(!flush);
          }}>
          <Typography style={{color:'red',fontSize:"18px",paddingLeft:'8px',fontWeight:'bold',cursor:'pointer'}} > 
          ×
          </Typography>
        </Box>
        
      {/* <img src = '/images/close.svg' style={{width:'10px', height:'10px'}}/> */}

    </Box>
  );
};
const DeleteAllView:React.FC = (props) => {
  const {allSelect, flush, setFlush, filter} = props;
  let count = 0;
  for (let i=0;i<allSelect.length;i++) {
    if(allSelect[i][6])
      count++;
  }
  return (
    <Box onClick={() => {
      console.log("*********111****************")
      for (let i=0;i<allSelect.length;i++) {
        allSelect[i][6] = false;
        allSelect[i][5] = null;
      }
      console.log("filter======",filter,allSelect)
      for (let i=0;i<filter.length;i++) {
        for(let m=0;m<filter[i][1].length;m++){
          if (filter[i][1][m][6]) {
            filter[i][1][m][6] = null;
          }
        }
        
      }
      setFlush(!flush);
    }} style={{display:'flex', flexDirection:'row', padding:'13rpx', alignItems:'center'}}>
      {count>0&&<Box style={{fontSize:'15px',padding:'20px',cursor:'pointer'}}>清除选项</Box> }
        
    </Box>
  );
};
 